"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupListItem = exports.GroupList = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
function getIds(groups) {
    const ids = [];
    for (const { id, children = [] } of groups) {
        ids.push(`${id}`);
        if (children.length > 0) {
            ids.push(...getIds(children));
        }
    }
    return ids;
}
const StyledTreeView = (0, styled_components_1.default)(lab_1.TreeView) `
  padding-left: 8px;
  .item-label {
    padding: 2px 16px;
    display: flex;
    min-height: 32.5px;
    align-items: center;
    .item-name {
      flex: 1;
    }
  }
  .item-actions {
    transition: opacity 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
    &.hidden {
      opacity: 0;
    }
  }
`;
const GroupList = props => {
    const { groups, hover, selected, onClick, onAddClick, onMouseOut, onMouseOver } = props;
    // only get ids for first render for default expanded values
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const defaultExpanded = (0, react_1.useMemo)(() => getIds(groups), []);
    return (react_1.default.createElement(StyledTreeView, { className: 'group-list', selected: selected ? selected.id.toString() : '', defaultExpanded: defaultExpanded, defaultExpandIcon: react_1.default.createElement(icons_1.ArrowRight, null), defaultCollapseIcon: react_1.default.createElement(icons_1.ArrowDropDown, null) }, groups.map(group => (react_1.default.createElement(exports.GroupListItem, { key: group.id, group: group, hover: hover, selected: selected, onClick: onClick, onAddClick: onAddClick, onMouseOut: onMouseOut, onMouseOver: onMouseOver })))));
};
exports.GroupList = GroupList;
const GroupListItem = props => {
    var _a;
    const { group } = props, itemProps = __rest(props, ["group"]);
    const { hover, selected, onClick, onAddClick, onMouseOut, onMouseOver } = itemProps;
    const isHover = group.id === (hover === null || hover === void 0 ? void 0 : hover.id);
    const isSelected = group.id === (selected === null || selected === void 0 ? void 0 : selected.id);
    const actionsClasses = ['item-actions'];
    !isHover && !isSelected && actionsClasses.push('hidden');
    return (react_1.default.createElement(lab_1.TreeItem, { nodeId: group.id.toString(), label: react_1.default.createElement("div", { className: 'item-label', 
            // use enter/leave to avoid add button disappearing
            onMouseEnter: () => onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(group), onMouseLeave: () => onMouseOut === null || onMouseOut === void 0 ? void 0 : onMouseOut(group) },
            react_1.default.createElement("div", { className: 'item-name' }, group.name),
            react_1.default.createElement("div", { className: actionsClasses.join(' ') },
                react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: event => {
                        event.stopPropagation();
                        onAddClick === null || onAddClick === void 0 ? void 0 : onAddClick(group);
                    } },
                    react_1.default.createElement(icons_1.Add, null)))), onLabelClick: event => {
            event.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick(group);
        } }, (_a = group.children) === null || _a === void 0 ? void 0 : _a.map(group => (react_1.default.createElement(exports.GroupListItem, Object.assign({ key: group.id, group: group }, itemProps))))));
};
exports.GroupListItem = GroupListItem;
exports.default = exports.GroupList;
//# sourceMappingURL=GroupList.js.map